import React, { type Ref } from 'react';

import Button from '@atlaskit/button/default/button';
import { ModalContextProvider } from '@atlassian/entry-points/modal-context-provider';
import { ModalTrigger } from '@atlassian/entry-points/modal-trigger';

import { loadingModalEntryPoint } from '../fixtures/constellation/loading-modal-entry-point';
import { RelayWrapper } from '../utils/wrapper';

export default function ModalTriggerLoading(): React.JSX.Element {
	return (
		<RelayWrapper>
			<ModalContextProvider>
				<ModalTrigger
					entryPoint={loadingModalEntryPoint}
					title="Example Modal"
					loadingText="Loading example modal"
				>
					{({ ref }) => (
						<Button ref={ref as Ref<HTMLButtonElement>} aria-haspopup="dialog">
							Show default loading
						</Button>
					)}
				</ModalTrigger>
			</ModalContextProvider>
		</RelayWrapper>
	);
}
